import { useFeatureIsOn } from '@growthbook/growthbook-react';

export default function FeatureFlag({ name, children, invert = false }) {
    const featureIsOn = useFeatureIsOn(name);
    if (!invert) {
        return !!featureIsOn && children;
    }
    return !featureIsOn && children;
}
